import isoLanguagesData from '../data/isoLanguagesData';

export default isoLanguagesData;
